import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Nav,
  Button,
  Form,
  Card,
  Dropdown,
  Table,
  Modal,
  Spinner,
} from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faCalendarAlt,
  faTicketAlt,
  faClipboardList,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import firebase from "firebase";
import { useCollection } from "react-firebase-hooks/firestore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL, DRIVE_UPLOAD } from "../../../config/index";
import axios from "axios";
import { languageText } from "./language.json";
import { connect, useSelector } from "react-redux";
import { sendEmail } from "../../../utils/index";
import { produce } from "immer";
import { languageText as languageTextToast } from "./language.json";
import _ from "lodash";
import Select from "react-select";
import DraggableList from "./DraggableList";
import SpeakersList from "./Templates/SpeakersList";

toast.configure();
const Doctors = (props) => {
  const { clinicId, clinicDetails } = useSelector((state) => state);
  const { currentLanguage } = props;
  const userDetails = firebase.auth().currentUser;
  const [deleteWarningModal, setDeleteWarningModal] = useState(false);
  const [selectedUID, setSelectedUID] = useState(null);

  const [showAddSpeakerModal, setShowAddSpeakerModal] = useState(false);
  const [doctorsSnapshot, loading, error] = useCollection(
    firebase.firestore().collection(`/clinics/${clinicId}/doctors`)
  );
  // const [speakerDataArray, setSpeakerDataArray] = useState([]);
  // const [sortedDoctors, setSortedSpeakers] = useState([]);
  let sortedDoctors = doctorsSnapshot?.docs.map((doctor) => ({
    ...doctor.data(),
    id: doctor.id,
  }));

  sortedDoctors = _.orderBy(sortedDoctors, "order_index", "asc");
  // useEffect(() => {
  //   const speakerDataArr =

  //   setSortedSpeakers(speakerDataArr);
  // }, [doctorsSnapshot]);

  const [
    speakersDataFromUsersCollection,
    setSpeakersDataFromUsersCollection,
  ] = useState([]);

  // const getUserProfileData = async (uid) => {
  //   const userData = await firebase
  //     .firestore()
  //     .collection(`users`)
  //     .doc(uid)
  //     .get();
  //   return userData;
  // };

  // const speakersDataUserCollectionHandler = async () => {
  //   let speakersUsers = await Promise.all(
  //     sortedDoctors.map(async (doctor) => {
  //       if (doctor.email_address && doctor.is_published) {
  //         let userData = await getUserProfileData(doctor.uid);
  //         return { ...userData.data(), ...doctor };
  //       }
  //     })
  //   );
  //   speakersUsers = speakersUsers.filter((doctor) => doctor !== undefined);
  //   setSpeakersDataFromUsersCollection((prev) => {
  //     const prevState = [...speakersUsers];
  //     return prevState;
  //   });
  // };

  // useEffect(() => {
  //   speakersDataUserCollectionHandler();
  // }, [sortedDoctors]);

  const [doctorDetails, setDoctorsDetails] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [saving, setSaving] = useState(false);

  const saveTextDataToStateHandler = (e) => {
    setDoctorsDetails((prevDoctorsData) => {
      return { ...prevDoctorsData, [e.target.name]: e.target.value };
    });
  };

  const saveHTMLDataToStateHandler = (name, data) => {
    setDoctorsDetails((prev) => {
      const updatedState = {
        ...prev,
        [name]: data,
      };
      return updatedState;
    });
  };

  const addSpeaker = async (e, doctorsData) => {
    e.preventDefault();
    // if (doctorsData.email_address.trim().length) {
    const emailAlreadyExists = doctorsData.email_address?.trim().length
      ? (
          await firebase
            .firestore()
            .collection(`/clinics/${clinicId}/doctors`)
            .where(
              "email_address",
              "==",
              doctorsData.email_address.toLowerCase()
            )
            .get()
        ).docs.length
      : false;
    if (!emailAlreadyExists) {
      let isUserExistsInConnect = await firebase
        .firestore()
        .collection("users")
        .where("email", "==", doctorsData.email_address.toLowerCase())
        .get();
      if (isUserExistsInConnect.empty) {
        toast.error("Email is not register with igesia.", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
        return;
      }
      const order_index = doctorsSnapshot.docs.length + 1;
      const imgSrcURL = doctorsData.img_src
        ? await uploadFile(doctorsData.img_src)
        : null;
      try {
        setSaving(true);
        await firebase
          .firestore()
          .collection(`/clinics/${clinicId}/doctors`)
          .doc(isUserExistsInConnect.docs[0].id)
          .set({
            first_name: doctorsData.first_name ?? "",
            last_name: doctorsData.last_name ?? "",
            bio: doctorsData.bio ?? "",
            img_src: imgSrcURL ?? "",
            order_index: +order_index,
            id: +order_index,
            email_address: doctorsData.email_address ?? "",
            user_role: 2,
            timestamp: new Date().valueOf(),
          });
        await sendEmail({
          to: doctorsData.email_address,
          subject: "You are invited to be a doctor at Blue Ocean Awards",
          content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi,</span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You are invited to be a doctor at Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /> <span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Please register as a visitor using the <strong style="background-color: #FFF000;">same email address</strong> where you are recieving this email invite. </span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://events.igesia.co/clinic/template/register/${doctorsData.email_address}" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Register now</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--><p style="font-size: 14px; line-height: 140%; margin-top:30px"> <br /> Please write to <a href="mailto:support@igesia.co"> support@igesia.co</a> for assistance. <br /></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
          from: '"igesia" <noreply@igesia.co>',
        });
        toast.success("Doctor added", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
      } catch (e) {
        console.error(e, "unable to write to db");
      } finally {
        setSaving(false);
        setDoctorsDetails({});
        setShowAddSpeakerModal(false);
      }
    } else {
      toast.error(languageTextToast[`${currentLanguage}`].error, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
      setSaving(false);
    }
    // } else {
    //   //set error email is empty
    //   toast.error(languageTextToast[`${currentLanguage}`].emailEmptyInBooth, {
    //     position: toast.POSITION.TOP_CENTER,
    //     hideProgressBar: true,
    //     autoClose: 3000,
    //   });
    // }
  };

  const sendReminder = async (email) => {
    try {
      const response = await sendEmail({
        to: email,
        subject: "You are invited to be a doctor at Blue Ocean Awards",
        content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi,</span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You are invited to be a doctor at Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /> <span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Please register as a visitor using the <strong style="background-color: #FFF000;">same email address</strong> where you are recieving this email invite. </span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://events.igesia.co/clinic/template/register/${email}" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Register now</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--><p style="font-size: 14px; line-height: 140%; margin-top:30px"> <br /> Please write to <a href="mailto:support@igesia.co"> support@igesia.co</a> for assistance. <br /></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
        from: '"igesia" <noreply@igesia.co>',
      });
      toast.success("Email sent successfully", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } catch (e) {
      toast.error(languageTextToast[`${currentLanguage}`].error, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    }
  };

  const updateSpeaker = async (e, doctorsData) => {
    e.preventDefault();
    // if (doctorsData.email_address.trim().length) {
    const order_index = doctorsData.order_index
      ? doctorsData.order_index
      : doctorsSnapshot.docs.length + 1;
    const imgSrcURL = doctorsData.img_src
      ? await uploadFile(doctorsData.img_src)
      : null;
    try {
      setSaving(true);
      firebase
        .firestore()
        .collection(`/clinics/${clinicId}/doctors`)
        .doc(doctorsData.id)
        .set({
          first_name: doctorsData.first_name ?? "",
          last_name: doctorsData.last_name ?? "",
          bio: doctorsData.bio ?? "",
          img_src: imgSrcURL ?? "",
          order_index: +order_index,
          id: +order_index,
          email_address: doctorsData.email_address ?? "",
          user_role: 2,
          timestamp: new Date().valueOf(),
        })
        .then(() => {
          toast.success("Doctor updated", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          });
        });
    } catch (e) {
      console.error(e, "unable to write to db");
    } finally {
      setSaving(false);
      setShowAddSpeakerModal(false);
      setIsUpdating(false);
      setDoctorsDetails({});
    }
    // } else {
    //   //set error email is empty
    //   toast.error(languageTextToast[`${currentLanguage}`].emailEmptyInBooth, {
    //     position: toast.POSITION.TOP_CENTER,
    //     hideProgressBar: true,
    //     autoClose: 3000,
    //   });
    // }
  };

  const deleteSpeakerHandler = async (uid) => {
    try {
      await firebase
        .firestore()
        .collection(`/clinics/${clinicId}/doctors`)
        .doc(uid)
        .delete();
      toast.success("Doctor deleted", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } catch (e) {
      console.error(e);
      toast.error("Error in deleting doctor", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    }
  };

  const editSpeakerHandler = async (uid) => {
    setShowAddSpeakerModal(true);
    try {
      const speakerData = await firebase
        .firestore()
        .collection(`/clinics/${clinicId}/doctors`)
        .doc(uid)
        .get();
      setDoctorsDetails(speakerData);
    } catch (e) {
      console.error(e);
    }
  };

  const uploadFile = async (file) => {
    if (file.name) {
      const fileData = new FormData();

      fileData.append("file", file, `${file.lastModified}-${file.name}`);
      fileData.append(
        "user_id",
        userDetails?.uid ?? "1gHTSDwzWRPW7KAUeTcscDFxs7z2"
      );

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      if (file) {
        try {
          let res = await axios.post(
            `${API_BASE_URL}${DRIVE_UPLOAD}`,
            fileData,
            config
          );
          return res.data.data["file_url"];
        } catch (error) {
          console.error(error, "error in writing file to db");
        }
      } else return "";
    } else {
      return file;
    }
  };

  const saveFileToStateHandler = (e) => {
    setDoctorsDetails((prevDoctorsData) => {
      return { ...prevDoctorsData, [e.target.name]: e.target.files[0] };
    });
  };

  const getWhetherURLOrLocalFile = (file) => {
    if (!file.name) {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };
  const publishSpeakerHandler = async (uid) => {
    try {
      await firebase
        .firestore()
        .collection(`/clinics/${clinicId}/doctors`)
        .doc(uid)
        .update({
          is_published: true,
        });
      toast.success(
        languageTextToast[`${currentLanguage}`].successfullyPublishedSpeaker,
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        }
      );
    } catch (e) {
      console.error(e, "error in saving to db");
      toast.error(languageTextToast[`${currentLanguage}`].error, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } finally {
      setSaving(false);
    }
  };
  const unPublishSpeakerHandler = async (uid) => {
    try {
      await firebase
        .firestore()
        .collection(`/clinics/${clinicId}/doctors`)
        .doc(uid)
        .update({
          is_published: false,
        });
      toast.success(
        languageTextToast[`${currentLanguage}`].successfullyUnpublishedSpeaker,
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        }
      );
    } catch (e) {
      console.error(e, "error in saving to db");
      toast.error(languageTextToast[`${currentLanguage}`].error, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
    } finally {
      setSaving(false);
    }
  };
  const img_src_url = doctorDetails.img_src
    ? getWhetherURLOrLocalFile(doctorDetails.img_src)
    : null;

  const speakerOnClickHandler = (speakerData) => {
    setIsUpdating(true);
    setDoctorsDetails(speakerData);
    setShowAddSpeakerModal(true);
  };

  // searching and filtering
  const [searchTerm, setSearchTerm] = useState("");
  const [regex, setRegex] = useState("");
  const [currentFilterCriteria, setCurrentFilterCriteria] = useState(null);
  const [currentSortCriteria, setCurrentSortCriteria] = useState(null);

  let filteredDataArray =
    currentSortCriteria !== null
      ? _.orderBy(
          sortedDoctors,
          currentSortCriteria.value.split("-")[0],
          currentSortCriteria.sortOrder
        )
      : sortedDoctors;

  const sortOptions = [
    { value: "first_name-asc", label: "First name: A-Z ", sortOrder: "asc" },
    { value: "first_name-desc", label: "First name: Z-A", sortOrder: "desc" },
    { value: "last_name-asc", label: "Last name: A-Z", sortOrder: "asc" },
    { value: "last_name-desc", label: "Last name: Z-A", sortOrder: "desc" },
  ];

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchTerm(e.target.value);
    const reg = _.escapeRegExp(searchTerm);
    // console.log(reg,"Reg")
    const regex = new RegExp(reg, "gi");
    setRegex(regex);
    //this.setState({ regex: regex })
  };

  // reordering
  const [isBeingReordered, setIsBeingReordered] = useState(false);

  // throttling
  const listReorderHandler = (newOrder) => {
    // new order will be an array of indices
    newOrder.forEach((order, index) => {
      // [1,0,3,2]
      if ((order !== undefined || order !== null) && sortedDoctors.length) {
        sortedDoctors[order].order_index = index;
      }
    });
    console.log(sortedDoctors, "sortedSpeaker");
  };

  const throttledReorder = _.throttle(listReorderHandler, 1000);

  const saveOrderIndexToDBHandler = async () => {
    try {
      sortedDoctors.forEach(async (doctor) => {
        await firebase
          .firestore()
          .collection(`/clinics/${clinicId}/doctors`)
          .doc(doctor.id)
          .update({
            order_index: doctor.order_index,
          });
      });
    } catch (e) {
      console.error(e, "error in changing the order");
    }
  };

  if (loading) return <Spinner size="sm" animation="border" />;
  if (error) return <h5>Something went wrong!</h5>;
  return (
    <>
      <div className="container-fluid text-light">
        <div className="col-md-12 h-100 pt-4" style={{ overflow: "auto" }}>
          <h5>Doctors Management</h5>
          <div className="row">
            <div className="col-md-6">
              <p className="small text-secondary">
                Create profiles for your doctors here. Once created, you’ll need
                to invite your doctor (via ticket or Magic Link). They will then
                have the option of accepting or editing your suggested profile.
              </p>
            </div>
          </div>
          <div className="row mb-2 justify-content-between">
            <div className="col-md-6">
              <div className="d-flex align-items-center rounded border w-100 search-bar bg-dark text-light">
                <div className="py-2 pr-2 pl-3 bg-dark text-light">
                  <FontAwesomeIcon icon={faSearch} size="sm" color="#aeaeae" />
                </div>
                <div className="flex-grow-1">
                  <Form.Control
                    type="text"
                    id="participantsSearch"
                    className="border-0 px-0 bg-dark text-light"
                    onChange={handleSearch}
                    placeholder={"Search by name, email"}
                    value={searchTerm}
                    style={{ margin: 0 }}
                  />
                </div>
                {searchTerm.length > 0 && (
                  <div
                    className="py-2 pl-2 pr-3"
                    onClick={() => setSearchTerm("")}
                  >
                    <FontAwesomeIcon icon={faTimes} color="#aeaeae" />
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <Select
                placeholder="Sort"
                options={sortOptions}
                defaultValue={sortOptions[0]}
                onChange={(e) => setCurrentSortCriteria(e)}
                className="w-100 "
              ></Select>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div></div>
            <div className="d-flex align-items-center">
              {/* <Button className="btn-sm btn-secondary disabled mr-2">
                Email Doctors
              </Button> */}
              <Button
                className="btn-sm btn-primary mr-2"
                onClick={() => setShowAddSpeakerModal(true)}
                disabled={doctorsSnapshot?.docs.length}
              >
                + New doctor
              </Button>
              {/* <Button className="btn-sm btn-secondary disabled mr-2">
                + New Category
              </Button> */}
              {/* <Button
                className="btn-sm btn-primary mr-2"
                onClick={() => setIsBeingReordered(true)}
              >
                Reorder
              </Button> */}
            </div>
          </div>
          {isBeingReordered ? (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  className="btn-sm btn-success disabled mr-2"
                  onClick={() => {
                    saveOrderIndexToDBHandler();
                    setIsBeingReordered(false);
                  }}
                >
                  Save
                </Button>
                <Button
                  className="btn-sm btn-danger mr-2"
                  onClick={() => setIsBeingReordered(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : null}
          <div className="mt-3 h-100" style={{ maxHeight: "70vh" }}>
            <div className="mb-5 pb-5 row mx-0">
              {searchTerm && searchTerm.trim().length ? (
                <>
                  {isBeingReordered ? (
                    <DraggableList
                      orderFunction={throttledReorder}
                      items={filteredDataArray}
                      variant="doctors"
                    />
                  ) : (
                    <>
                      {filteredDataArray
                        .filter((item) => {
                          return (
                            item.display_name?.match(regex) ||
                            item.email_address?.match(regex)
                          );
                        })
                        .map((doctor, index) => {
                          return (
                            <SpeakersList
                              doctor={doctor}
                              index={index}
                              sendReminder={sendReminder}
                              speakerOnClickHandler={speakerOnClickHandler}
                              unPublishSpeakerHandler={unPublishSpeakerHandler}
                              publishSpeakerHandler={publishSpeakerHandler}
                              setSelectedUID={setSelectedUID}
                              setDeleteWarningModal={setDeleteWarningModal}
                            />
                          );
                        })}
                    </>
                  )}
                </>
              ) : (
                <>
                  {isBeingReordered ? (
                    <DraggableList
                      orderFunction={throttledReorder}
                      items={filteredDataArray}
                      variant="doctors"
                    />
                  ) : (
                    <>
                      {filteredDataArray.map((doctor, index) => {
                        return (
                          <SpeakersList
                            doctor={doctor}
                            index={index}
                            sendReminder={sendReminder}
                            speakerOnClickHandler={speakerOnClickHandler}
                            unPublishSpeakerHandler={unPublishSpeakerHandler}
                            publishSpeakerHandler={publishSpeakerHandler}
                            setSelectedUID={setSelectedUID}
                            setDeleteWarningModal={setDeleteWarningModal}
                          />
                        );
                      })}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* modal for add ticket */}

      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAddSpeakerModal}
        onHide={() => {
          setDoctorsDetails({});
          setIsUpdating(false);
          setShowAddSpeakerModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add doctor information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <Form.Group className="col-md-12">
                <Form.Label>Profile picture</Form.Label>
                {doctorDetails.img_src ? (
                  <div className="mb-2">
                    <img
                      alt=""
                      src={img_src_url}
                      className="img-fluid rounded-circle"
                      style={{ width: "100px", height: "100px" }}
                    ></img>
                  </div>
                ) : null}
                <Form.Control
                  type="file"
                  accept="image/*"
                  name="img_src"
                  onChange={(e) => saveFileToStateHandler(e)}
                  className="border p-1 rounded"
                  style={{ cursor: "pointer" }}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  value={doctorDetails.first_name}
                  placeholder="First Name"
                  name="first_name"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  type="text"
                  value={doctorDetails.last_name}
                  placeholder="Last name"
                  name="last_name"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-12">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={doctorDetails.email_address}
                  name="email_address"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-12">
                <Form.Label>Bio</Form.Label>
                <CKEditor
                  id="editor"
                  editor={ClassicEditor}
                  config={{
                    toolbar: [
                      "heading",
                      "bold",
                      "italic",
                      "link",
                      "numberedList",
                      "bulletedList",
                      "undo",
                      "redo",
                    ],
                  }}
                  className="mb-3"
                  data={doctorDetails.bio ?? ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    saveHTMLDataToStateHandler("bio", data);
                  }}
                  style={{ height: 400 }}
                />
              </Form.Group>
              {/* <Form.Group className="col-md-6">
                <Form.Label>Twitter</Form.Label>
                <Form.Control type="text" placeholder="Twitter" />
              </Form.Group>
              <Form.Group className="col-md-6 mx-auto">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control type="text" placeholder="LinkedIn" />
              </Form.Group> */}
            </div>
            {!isUpdating ? (
              <Button
                variant="primary"
                className="w-100"
                onClick={(e) => addSpeaker(e, doctorDetails)}
                disabled={saving}
              >
                {saving ? <Spinner animation="border" size="sm" /> : "Submit"}
              </Button>
            ) : (
              <Button
                variant="primary"
                className="w-100"
                onClick={(e) => updateSpeaker(e, doctorDetails)}
                disabled={saving}
              >
                {saving ? <Spinner animation="border" size="sm" /> : "Update"}
              </Button>
            )}
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={deleteWarningModal}
        onHide={() => {
          setSelectedUID("");
          setDeleteWarningModal(false);
        }}
        centered
      >
        <Modal.Header closeButton>Confirm deletion</Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete? This action cannot be reversed</p>
          {/* <p>Contine ?</p> */}
          <div className="d-flex justify-content-end">
            <Button
              variant="secondary"
              className="btn-sm mr-3"
              onClick={() => setDeleteWarningModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => {
                deleteSpeakerHandler(selectedUID);
                setDeleteWarningModal(false);
              }}
            >
              Yes, delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default connect((state) => ({ currentLanguage: "EN" }))(Doctors);
